/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Config')
    .constant('RoutePaths', {
        NODES: '/nodes',
        SIGNED_FILES: '/signed_files',
        REQUESTED_FILES: '/requested_files',
        PUBLIC_FOLDER: '/public_folder',
        SHARE_GROUPS: '/share_groups',
    })
    .config(['$routeProvider', 'ENV', 'RoutePaths',
        function ($routeProvider, ENV, RoutePaths) {
            $routeProvider
                .when('/', {
                    template: '',
                    controller: ['ReturnPage', '$location', '$rootScope', function (ReturnPage, $location, $rootScope) {
                        var returnPath = ReturnPage.get(),
                            defaultPath = $rootScope.defaultPath || RoutePaths.NODES;

                        $location.url(returnPath || defaultPath);
                        $location.replace();
                    }]
                })
                .when(RoutePaths.NODES, {
                    templateUrl: ENV['templatesPath'] + 'nodes/index.html',
                    controller: 'SyncAndShareNodesController',
                    reloadOnSearch: false
                })
                .when(RoutePaths.NODES + '/:uuid', {
                    templateUrl: ENV['templatesPath'] + 'nodes/index.html',
                    controller: 'SyncAndShareNodesController',
                    reloadOnSearch: false
                })
                .when('/links', {
                    templateUrl: ENV['templatesPath'] + 'links/index.html',
                    controller: 'LinksController'
                })
                .when('/log', {
                    templateUrl: ENV['templatesPath'] + 'log/index.html',
                    controller: 'LogController'
                })
                .when('/notarized_files', {
                    templateUrl: ENV['templatesPath'] + 'notarized_files/index.html',
                    controller: 'NotarizedFilesController'
                })
                .when(RoutePaths.SIGNED_FILES, {
                    templateUrl: ENV['templatesPath'] + 'signed_files/index.html',
                    controller: 'SignedFilesController',
                    reloadOnSearch: false
                })
                .when(RoutePaths.REQUESTED_FILES, {
                    templateUrl: ENV['templatesPath'] + 'requested_files/index.html',
                    controller: 'RequestedFilesController',
                    reloadOnSearch: false
                })
                .when(RoutePaths.PUBLIC_FOLDER + '/:uuid', {
                    templateUrl: ENV['templatesPath'] + 'nodes/public_folder.html',
                    controller: 'PublicFolderController'
                })
                .when(RoutePaths.SHARE_GROUPS, {
                    templateUrl: ENV['templatesPath'] + 'share_groups/index.html',
                    controller: 'ShareGroupsController',
                    reloadOnSearch: false
                })
                .otherwise({
                    redirectTo: '/'
                });
        }
    ]);
